import Crud from "../Crud";
import MUIBlueColor from "@mui/material/colors/blue";

export default class DiagnosisCode extends Crud {
    static getDisplayName(diagnosisCode) {
        if (diagnosisCode.code && diagnosisCode.code.length > 3) {
            return `${diagnosisCode.code.slice(0, 3)}.${diagnosisCode.code.slice(3)}`;
        }
        return diagnosisCode.code;
    }

    static getDetailedDisplayName(diagnosisCode) {
        return `${this.getDisplayName(diagnosisCode)} - ${diagnosisCode.descriptionShort || diagnosisCode.description}`;
    }

    static match(diagnosisCode, query) {
        return (
            (diagnosisCode.code && diagnosisCode.code.toLowerCase().includes(query)) ||
            diagnosisCode.id === +query
        );
    }

    static sort(diagnosisCodes) {
        return diagnosisCodes.sort((a, b) => a.code.localeCompare(b.code));
    }

    static getBaseColor() {
        return MUIBlueColor;
    }

    static getIconName() {
        return "Medical";
    }
}
